import React from 'react';

const Empty = (props) => {
    return (
    <div>
    </div>    
    );
}

export default Empty;